<template>
    <Register type="patient"/>
</template>

<script>
// @ is an alias to /src
import Register from '@/components/auth/Register'

export default {
  name: 'RegisterPatient',
  components: {
    Register
  }
}
</script>
